import { INTEGRATION_TYPE } from "@/Pages/Integrations/types";
import { ROUTES } from "@/shared";
import { useIntegrationsDialogStore } from "@/stores/useIntegrationsDialogStore";

import PageHeaderActions from "../PageHeaderActions";

const AnalysisProvidersHeaderActions = () => {
  const { openAddDialog } = useIntegrationsDialogStore();

  return (
    <PageHeaderActions
      route={ROUTES.AnalysisProviders}
      openDialog={() => openAddDialog(INTEGRATION_TYPE.AnalysisProvider)}
      addItem
    >
      <></>
    </PageHeaderActions>
  );
};

export default AnalysisProvidersHeaderActions;
